import React, { useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import {
  useLocation,
  useParams,
  withRouter,
  RouteComponentProps,
} from "react-router";
import Page from "components/Layout/Page/Page";
import LayoutContainer from "components/Layout/Container";
import Header from "components/Layout/Header/Header";
import PublishButton from "components/PublishButton/PublishButton";
import PublishStatus from "components/PublishStatus/PublishStatus";
import {
  BackButtonWrapper,
  Container,
  ControlContainer,
  ControlsContainer,
  PublishStatusWrapper,
} from "./styles";
import LoadingButton from "components/LoadingButton/LoadingButton";
import withGlobalPopup from "components/Popup/withGlobalPopup";
import { withGlobalSnackbar } from "services/snackbar/snackbarContext";
import ManualBadgeForm from "../ManualBadgeForm/ManualBadgeForm";
import ManualBadgeLogs from "../ManualBadgeLogs/ManualBadgeLogs";
import ManualBadgeCsvForm from "../ManualBadgeCsvForm/ManualBadgeCsvForm";
import ROUTES from "navigation/routes";

interface LocationState {
  editMode?: boolean;
}

interface ManualBadgeDetailsProps extends RouteComponentProps {}

const ManualBadgeDetails: React.FC<ManualBadgeDetailsProps> = (
  props: ManualBadgeDetailsProps,
) => {
  const location = useLocation<LocationState>();
  const manualBadge: {
    manualBadgeId: string;
  } = useParams();
  const [publishStatus, setPublishStatus] = useState("");
  const [successfulUsers, setSuccessfulUsers] = useState(0);
  const [isEditMode, setIsEditMode] = useState(location.state?.editMode);
  const [isNewItem, setIsNewItem] = useState(
    manualBadge.manualBadgeId === undefined,
  );
  const [hasUsers, setHasUsers] = useState(false);
  const [isManagingUsers, setIsManagingUsers] = useState(false);
  const [successfullUserAmount, setSuccessfullUserAmount] = useState(
    successfulUsers || 0,
  );

  useEffect(() => {
    setHasUsers(successfullUserAmount > 0);
    setSuccessfulUsers(successfullUserAmount);
  }, [successfullUserAmount]);

  const onBackClick = () => {
    const onAccept = () => props.history.push(ROUTES.IN_APP_MANUAL_BADGES);
    onAccept();
  };

  const onManageUsers = (value: boolean) => {
    setIsManagingUsers(value);
  };

  const handleSuccessfulUsersUpdate = (newSuccessfulUsersAmount: number) => {
    setSuccessfullUserAmount(newSuccessfulUsersAmount);
  };

  return (
    <LayoutContainer header={<Header controls={<PublishButton />} />}>
      <Page
        title="Manual Badge Details"
        leftControls={
          publishStatus && (
            <PublishStatusWrapper>
              <PublishStatus status={publishStatus} />
            </PublishStatusWrapper>
          )
        }
        topControls={
          <BackButtonWrapper>
            <Button
              color="secondary"
              variant="text"
              startIcon={<KeyboardBackspaceIcon />}
              onClick={onBackClick}
            >
              Back to Manual Badges
            </Button>
          </BackButtonWrapper>
        }
      >
        <Container>
          {!isEditMode && !isManagingUsers && (
            <ControlsContainer>
              <>
                <ControlContainer>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setIsEditMode(true)}
                    fullWidth
                  >
                    Edit
                  </Button>
                </ControlContainer>
                <ControlContainer width="150px">
                  <LoadingButton
                    onClick={() => onManageUsers(true)}
                    variant="contained"
                    color="primary"
                    fullWidth
                  >
                    Manage Users
                  </LoadingButton>
                </ControlContainer>
              </>
            </ControlsContainer>
          )}

          <ManualBadgeForm
            isEditMode={isEditMode}
            isNewItem={isNewItem}
            badgeId={manualBadge.manualBadgeId}
            setIsEditMode={setIsEditMode}
            onBack={onBackClick}
            setPublishStatus={setPublishStatus}
            setSuccessfulUsers={setSuccessfulUsers}
            setHasUsers={setHasUsers}
          />
          {!isNewItem && !isEditMode && isManagingUsers && (
            <ManualBadgeCsvForm
              onManageUsers={onManageUsers}
              onSuccessfulUsersUpdate={handleSuccessfulUsersUpdate}
            />
          )}
          {!isNewItem && !isEditMode && !isManagingUsers && hasUsers && (
            <ManualBadgeLogs successfulAmount={successfulUsers} />
          )}
        </Container>
      </Page>
    </LayoutContainer>
  );
};

export default withGlobalPopup(
  withGlobalSnackbar(withRouter(ManualBadgeDetails)),
);
